// extracted by mini-css-extract-plugin
module.exports = {"map":"WebSocketReceiver_map_i3Arq"};